import { useTitle } from "@/hooks/use-title.hook.ts";
import { FeedbackScoreCardFill } from "@/pages/recruit/scorecards/feedback/components/FeedbackScoreCardFill.tsx";
import { FeedbackScoreCardFinal } from "@/pages/recruit/scorecards/feedback/components/FeedbackScoreCardFinal.tsx";
import { FeedbackScoreCardStart } from "@/pages/recruit/scorecards/feedback/components/FeedbackScoreCardStart.tsx";
import { useEmployeeMe } from "@/queries/employees/use-employees.query.ts";
import { useScoreCardFeedbackById } from "@/queries/recruit/use-scorecards.query.ts";
import { ApiScoreCardStatus } from "@/types/recruit/scorecard.types.ts";
import { Button, FullScreenPage, Skeleton } from "@skailer-com/uikit";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

export function FeedbackScoreCard() {
  const { feedback_id } = useParams();
  const feedbackIdNumber = feedback_id ? parseInt(feedback_id) : undefined;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: employeeMe } = useEmployeeMe();
  const [forcedState, setForcedState] = useState<ApiScoreCardStatus | undefined>();

  const { data: feedback } = useScoreCardFeedbackById({
    employeeId: employeeMe?.id,
    feedbackId: feedbackIdNumber,
  });

  useTitle(
    feedback && feedback.applicant
      ? `${feedback.applicant.first_name} ${feedback.applicant.last_name}`
      : undefined,
    feedback?.scorecard.title,
    t("scorecards:feedback")
  );

  if (feedback) {
    const status = forcedState || feedback.status;

    if (status == ApiScoreCardStatus.invited) {
      return <FeedbackScoreCardStart feedback={feedback} />;
    } else if (status == ApiScoreCardStatus.in_progress) {
      return <FeedbackScoreCardFill feedback={feedback} setForcedState={setForcedState} />;
    } else if (status == ApiScoreCardStatus.completed) {
      return <FeedbackScoreCardFinal feedback={feedback} setForcedState={setForcedState} />;
    }
  }

  return (
    <FullScreenPage
      title={`${t("scorecards:scorecard")}: ${t("common:loading")}...`}
      backSlot={
        <Button
          variant={"secondary"}
          size={"lg"}
          onClick={() => {
            navigate(-1);
          }}
        >
          {t("common:exit")}
        </Button>
      }
    >
      <Skeleton className={"w-full h-10"} />
    </FullScreenPage>
  );
}
